import React, { createContext, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { localizationModule } from "./text";

export const Context = createContext();

const ContextProvider = ({ children }) => {
  const r = {
    ...localizationModule,
    current: window.location.pathname.split("/")?.at(1) === "es" ? "es" : "en",
  };
  const [value, setValue] = useState({ localizationModule: r });

  return (
    <Context.Provider value={{ value, setValue }}>{children}</Context.Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter
    basename={
      window.location.pathname.split("/")?.at(1) === "es" ? "es" : undefined
    }
  >
    <ContextProvider>
      <App />
    </ContextProvider>
  </BrowserRouter>
);

reportWebVitals();
